import { type JSX, MouseEvent } from 'react';

import { ButtonColors } from 'types';
import { Button } from 'components/button';

import * as Styles from './styles';
import { ButtonTabsProps } from './types';

const ButtonTabs = function <T extends string = string>({
  onClick,
  buttons,
  selected,
  className,
  selectedStyles,
  defaultButtonColor,
}: ButtonTabsProps<T>): JSX.Element {
  const handleClick = (e: MouseEvent<HTMLButtonElement>): void => {
    const value = e.currentTarget.value as T;

    if (value === selected) {
      return;
    }
    onClick(value);
  };

  return (
    <Styles.List className={className}>
      {buttons.map((props, idx) => {
        const isSelected = props.value === selected;
        const style = isSelected ? selectedStyles : undefined;
        return (
          <li key={`${props.text}-${idx}`}>
            <Button
              style={style}
              padding="4px 12px"
              onClick={handleClick}
              transparent={!isSelected}
              nativeColorText={!isSelected}
              colorType={
                defaultButtonColor && !isSelected
                  ? defaultButtonColor
                  : ButtonColors.LightBlue
              }
              {...props}
            />
          </li>
        );
      })}
    </Styles.List>
  );
};

export { ButtonTabs };
export type { ButtonTabsProps };
